import { keyframes } from '@emotion/react'
import {
  IconButton,
  inputBaseClasses,
  listClasses,
  paperClasses,
  svgIconClasses,
  textFieldClasses,
  CSSObject,
  styled,
  Typography as TypographyBase,
  Popover as PopoverBase,
  MenuItem as MenuItemBase,
} from '@mui/material'

import { TextField as TextFieldBase } from '../../utils/shared/TextField'

export const Container = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  position: 'relative',
}))

export const Flag = styled('div')<{ image?: string }>(({ theme, image }) => ({
  width: theme.spacing(2.25),
  height: theme.spacing(2.25),
  flexBasis: theme.spacing(2.25),
  minWidth: theme.spacing(2.25),
  backgroundImage: `url(${image})`,
  border: `1px solid rgb(255, 255, 255)`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: '50%',
}))

// This "animation" is only used to trigger the `animationstart` event so JS can
// know when the autofill is being used.
export const onAutofillStart = keyframes`
  from {}
  to {}
`

// This "animation" is only used to trigger the `animationstart` event so JS can
// know when the autofill is being used.
export const onAutofillCancel = keyframes`
  /* Adding this comment so emotion will generate a different animation name than onAutofillStart */
  from {}
  to {}
`

export const TextField = styled(TextFieldBase)(() => ({
  [`&.${textFieldClasses.root} .${inputBaseClasses.input}`]: {
    paddingLeft: 0,

    ['&:-webkit-autofill']: {
      animationName: onAutofillStart,
    },

    ['&:not(:-webkit-autofill)']: {
      animationName: onAutofillCancel,
    },
  },
}))

export const Button = styled('button')(({ theme }) => ({
  cursor: 'pointer',
  appearance: 'none',
  border: 'none',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  left: theme.spacing(2),
  top: '24px',
  zIndex: 20,
  backgroundColor: 'transparent',

  [`& .${svgIconClasses.root}`]: {
    fontSize: '16px',
    color: theme.palette.grey[800],
  },
}))

export const Popover = styled(PopoverBase)(({ theme }) => ({
  [`& .${listClasses.root}`]: {
    padding: 0,
  },

  [`& .${paperClasses.root}`]: {
    maxHeight: '300px',
    maxWidth: '300px',
    borderRadius: '0 0 4px 4px',
    boxShadows: theme.shadows[4],
  },
}))

export const MenuItem = styled(MenuItemBase)(({ theme }) => ({
  ...(theme.typography['Lato Body 1'] as CSSObject),
  color: theme.palette.grey[800],
  padding: theme.spacing(1.5, 2),

  '&.Mui-selected': {
    backgroundColor: theme.palette.grey[100],
  },

  '&:hover': {
    backgroundColor: theme.palette.primary[50],
  },
}))

export const MenuItemText = styled(TypographyBase)(({ theme }) => ({
  color: theme.palette.grey[800],
  marginLeft: theme.spacing(1),
  fontSize: '16px',
}))

export const CallingCode = styled('span')(() => ({
  padding: '22px 6px 3px 40px',
  zIndex: 2,
}))

export const SearchClearButton = styled(IconButton)(() => ({
  width: '30px',
  height: '30px',
  zIndex: 2,

  [`& .${svgIconClasses.root}`]: {
    fontSize: '20px',
  },
}))
